import React from 'react';
import { BaseConfig } from '../BaseConfig';
import ContnueButton from '../ui/ContinueButton';
import { UIProperties } from '../UIProperties';

import './GeneralAlert.css'
import { GeneralButtonConfig } from './GeneralButton';

const GeneralAlert = (props: UIProperties<GeneralAlertConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container">
			<div aria-label={props.parameters.title} className="alert-container center-on-container modal-disable-select">
				<img src="./assets/images/general/components/general_alert/window_mentor_blank.png"/>
				{props.parameters.smallerTitle ? 
				(<p className="alert-title title-font" style={{fontSize: '16pt'}}>{props.parameters.title}</p>) : 
				(<p className="alert-title title-font">{props.parameters.title}</p>)}
				<div className="alert-desc-container">
					<div className="alert-desc-left">
						<img className="center-on-container" src={props.parameters.img}/>
					</div>
					{props.parameters.useBigText ? (
						<div className="alert-desc-right" style={{
							width: '464px',
							position: 'absolute',
							height: '245px',
							right: '10px'
						}}>
							<p tabIndex={0} id='first-object-generalAlert' className="alert-desc big-description-font" style={{
								position: 'absolute',
								top: '50%',
								left: '0',
								transform: 'translate(0, -50%)',
								margin: 0
							}}>{props.parameters.text}</p>
							<ContnueButton parameters= {{
								ariaLbl: props.parameters.unseenText,
								id:'last-object-generalAlert',
								srcMain: props.parameters.srcMain ? props.parameters.srcMain : './assets/images/general/buttons/button_continue_main.png',
								srcDown: props.parameters.srcDown ? props.parameters.srcDown : './assets/images/general/buttons/button_continue_down.png',
								srcDisabled: props.parameters.srcDisabled ? props.parameters.srcDisabled : './assets/images/general/buttons/button_continue_main.png',
								top: '179px',
								left: '332px',
								width: '160px',
								onClicked: props.parameters.onContinueClicked
							}}/>
						</div>
					) : (
						<div className="alert-desc-right" style={{
							width: '464px',
							position: 'absolute',
							height: '245px',
							right: '10px'
						}}>
							<div style={{
								height: '157px',
								margin: '10px',
								position: 'relative'
							}}>
								<p tabIndex={0} id='first-object-generalAlert' className="alert-desc regular-description-font" style={{
									position: 'absolute',
									top: '0',
									left: '0',
									transform: 'translate(0, 0)',
									margin: 0
								}} dangerouslySetInnerHTML={{ __html: props.parameters.text }}></p>
							</div>

							<ContnueButton parameters= {{
								ariaLbl: props.parameters.unseenText,
								id:'last-object-generalAlert',
								srcMain: props.parameters.srcMain ? props.parameters.srcMain : './assets/images/general/buttons/button_continue_main.png',
								srcDown: props.parameters.srcDown ? props.parameters.srcDown : './assets/images/general/buttons/button_continue_down.png',
								srcDisabled: props.parameters.srcDisabled ? props.parameters.srcDisabled : './assets/images/general/buttons/button_continue_main.png',
								top: '179px',
								left: '332px',
								width: '160px',
								onClicked: props.parameters.onContinueClicked
							}}/>
						</div>
					)}
				</div>
			</div>
		</div>
	);

};

export interface GeneralAlertConfig extends BaseConfig {
	title: string;
	srcMain?: string;
	srcDown?: string;
	srcDisabled?: string;
	text: string;
	smallerTitle?: boolean;
	useBigText?: boolean;
	img: string;
	unseenText?: string;
	onContinueClicked: () => void;
}

export default GeneralAlert;